import React from 'react'
import ReactDOM from 'react-dom/client'
import './index.css'
import App from './App'
import '../src/assets/global.css'

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(<App />)

